type PaddingVariant = 'none' | 'small' | 'medium' | 'large';

interface Padding {
  top?: PaddingVariant;
  bottom?: PaddingVariant;
}

export const getSectionPaddingClasses = (styles: Record<string, string>, padding?: Padding) => [
  (padding?.top || padding?.bottom) && styles.custom_padding,
  padding?.top && styles[`top_${padding.top}`],
  padding?.bottom && styles[`bottom_${padding.bottom}`]
];
